import { CityPreset } from '../types/spot';

export const CITIES_DATA: CityPreset[] = [
  {
    id: 'seoul-jongno',
    name: 'Seoul (Jongno / Palaces)',
    nameDe: 'Seoul (Jongno / Paläste)',
    nameKr: '서울 종로',
    region: 'Seoul',
    lat: 37.5759,
    lng: 126.9768,
    description: 'Heart of royal Seoul: Gyeongbokgung, Bukchon Hanok, Insadong & Gwanghwamun.',
    addressKr: '서울특별시 종로구 사직로 161 (세종로)',
  },
  {
    id: 'seoul-myeongdong',
    name: 'Seoul (Myeongdong / Namsan)',
    nameDe: 'Seoul (Myeongdong / Namsan)',
    nameKr: '서울 명동 / 남산',
    region: 'Seoul',
    lat: 37.5636,
    lng: 126.9838,
    description: 'Vibrant center, N Seoul Tower cable car, street culture & night lights.',
    addressKr: '서울특별시 중구 명동길 43',
  },
  {
    id: 'seoul-hongdae',
    name: 'Seoul (Hongdae / Yeonnam)',
    nameDe: 'Seoul (Hongdae / Yeonnam)',
    nameKr: '서울 홍대 / 연남',
    region: 'Seoul',
    lat: 37.5568,
    lng: 126.9242,
    description: 'Youth fashion, indie street art, cafe street, busking & Yeonnam forest park.',
    addressKr: '서울특별시 마포구 양화로 160 (동교동)',
  },
  {
    id: 'seoul-gangnam',
    name: 'Seoul (Gangnam / COEX / Jamsil)',
    nameDe: 'Seoul (Gangnam / COEX / Jamsil)',
    nameKr: '서울 강남 / 잠실',
    region: 'Seoul',
    lat: 37.5130,
    lng: 127.0583,
    description: 'Starfield Library, Bongeunsa Temple, Lotte World Tower & luxury avenues.',
    addressKr: '서울특별시 강남구 영동대로 513 (코엑스)',
  },
  {
    id: 'seoul-seongsu',
    name: 'Seoul (Seongsu-dong / Seoul Forest)',
    nameDe: 'Seoul (Seongsu / Seoul Forest)',
    nameKr: '서울 성수동 / 서울숲',
    region: 'Seoul',
    lat: 37.5445,
    lng: 127.0440,
    description: 'Brooklyn of Seoul: Industrial-chic cafes, pop-ups, red bricks & nature.',
    addressKr: '서울특별시 성동구 서울숲2길 32-14',
  },
  {
    id: 'busan-haeundae',
    name: 'Busan (Haeundae / Blueline)',
    nameDe: 'Busan (Haeundae / Blueline)',
    nameKr: '부산 해운대',
    region: 'Busan',
    lat: 35.1587,
    lng: 129.1604,
    description: 'Ocean coastline, Haeundae Beach, Sky Capsule train & Haedong Yonggungsa.',
    addressKr: '부산광역시 해운대구 해운대해변로 264',
  },
  {
    id: 'busan-gamcheon',
    name: 'Busan (Gamcheon / Nampo / Jagalchi)',
    nameDe: 'Busan (Gamcheon / Nampo)',
    nameKr: '부산 감천 / 남포',
    region: 'Busan',
    lat: 35.0975,
    lng: 129.0106,
    description: 'Colorful hillside village, coastal tunnels, Little Prince photo spots.',
    addressKr: '부산광역시 사하구 감내2로 203 (감천동)',
  },
  {
    id: 'busan-gwangalli',
    name: 'Busan (Gwangalli Beach)',
    nameDe: 'Busan (Gwangalli Strand)',
    nameKr: '부산 광안리',
    region: 'Busan',
    lat: 35.1532,
    lng: 129.1186,
    description: 'Diamond Bridge iconic suspension view, drone light shows & beachside cafes.',
    addressKr: '부산광역시 수영구 광안해변로 219',
  },
  {
    id: 'jeju-city',
    name: 'Jeju City (Airport / Ido / Vegan & Culture Hub)',
    nameDe: 'Jeju-Stadt (Flughafen / Ido / Veggie-Hotspot)',
    nameKr: '제주시 / 공항 / 이도동',
    region: 'Jeju',
    lat: 33.4996,
    lng: 126.5312,
    description: 'Inselhauptstadt: Dasoni Hanok-Teehaus, Loving Hut, Bagdad Indian, Samseonghyeol & Dongmun-Nachtmarkt.',
    addressKr: '제주특별자치도 제주시 광양9길 10 (이도이동)',
  },
  {
    id: 'jeju-aewol',
    name: 'Jeju (Aewol / Hyeopjae / West Coast)',
    nameDe: 'Jeju (Aewol / Hyeopjae / Westküste)',
    nameKr: '제주 애월 / 협재 / 한림',
    region: 'Jeju',
    lat: 33.4623,
    lng: 126.3115,
    description: 'West-Jeju: Türkisblauer Hyeopjae-Strand, And You veganes Bistro, Handam-Küstenpfad & Sonnenuntergänge.',
    addressKr: '제주특별자치도 제주시 애월읍 애월로 11',
  },
  {
    id: 'jeju-gujwa',
    name: 'Jeju (Gujwa / Sehwa / East Coast)',
    nameDe: 'Jeju (Gujwa / Sehwa / Ost-Jeju)',
    nameKr: '제주 구좌읍 / 세화리',
    region: 'Jeju',
    lat: 33.5248,
    lng: 126.8542,
    description: 'Insider-Liebling Ost-Jeju: Ruhige Vulkankegel (Oreums), Karotten-Brunch-Cafés, Meerblick-Bistros & Boutiquen.',
    addressKr: '제주특별자치도 제주시 구좌읍 세화리 3643-8',
  },
  {
    id: 'jeju-seongsan',
    name: 'Jeju (Seongsan / East Coast)',
    nameDe: 'Jeju (Seongsan / Ostküste)',
    nameKr: '제주 성산일출봉',
    region: 'Jeju',
    lat: 33.4581,
    lng: 126.9426,
    description: 'UNESCO Sunrise Peak volcanic crater, Seopjikoji cliffs & Tadao Ando Yumin Museum.',
    addressKr: '제주특별자치도 서귀포시 성산읍 일출로 284-12',
  },
  {
    id: 'jeju-jungmun',
    name: 'Jeju (Jungmun / Jusangjeolli / South Coast)',
    nameDe: 'Jeju (Jungmun / Jusangjeolli / Südküste)',
    nameKr: '제주 중문 / 서귀포',
    region: 'Jeju',
    lat: 33.2435,
    lng: 126.4258,
    description: 'Süd-Jeju: Jusangjeolli Basaltsäulen, Yakcheonsa Tempel, Jeongbang Wasserfall ins Meer & Veke Moosgarten.',
    addressKr: '제주특별자치도 서귀포시 이어도로 272 (대포동)',
  },
  {
    id: 'jeju-seogwipo',
    name: 'Jeju (Seogwipo / South Coast)',
    nameDe: 'Jeju (Seogwipo / Südküste)',
    nameKr: '제주 서귀포',
    region: 'Jeju',
    lat: 33.2465,
    lng: 126.5645,
    description: 'Veke Moosgarten-Café, Wasserfälle ins Meer, Olle Trail 7 & subtropische Natur.',
    addressKr: '제주특별자치도 서귀포시 칠십리로 214 (정방동)',
  },
  {
    id: 'gyeongju',
    name: 'Gyeongju (Historic Capital)',
    nameDe: 'Gyeongju (Historische Hauptstadt)',
    nameKr: '경주 역사지구',
    region: 'Gyeongju',
    lat: 35.8347,
    lng: 129.2190,
    description: 'Ancient Silla tombs, Bulguksa temple, illuminated Woljeonggyo bridge & Wolji pond.',
    addressKr: '경상북도 경주시 계림로 9 (황남동)',
  },
  {
    id: 'suwon',
    name: 'Suwon (Hwaseong Fortress)',
    nameDe: 'Suwon (Hwaseong Festung)',
    nameKr: '수원 화성',
    region: 'Gyeonggi',
    lat: 37.2874,
    lng: 127.0178,
    description: 'UNESCO massive fortress wall, hot air balloon flight & cozy palace alleys.',
    addressKr: '경기도 수원시 팔달구 정조로 825',
  },
  {
    id: 'incheon-inha',
    name: 'Incheon (Inha Univ / Michuhol)',
    nameDe: 'Incheon (Inha-Universität / Michuhol)',
    nameKr: '인천 인하대 / 미추홀구',
    region: 'Incheon',
    lat: 37.4504,
    lng: 126.6535,
    description: 'Inha University campus, international cafes & Michuhol-gu.',
    addressKr: '인천광역시 미추홀구 인하로 100 (용현동)',
  },
  {
    id: 'seoul-itaewon',
    name: 'Seoul (Itaewon / Hannam / Haebangchon)',
    nameDe: 'Seoul (Itaewon / Hannam / HBC)',
    nameKr: '서울 이태원 / 한남동',
    region: 'Seoul',
    lat: 37.5345,
    lng: 126.9942,
    description: 'Global gourmet capital, premier vegan restaurants, designer boutiques & Leeum Museum.',
    addressKr: '서울특별시 용산구 이태원로 179',
  },
  {
    id: 'incheon-songdo',
    name: 'Incheon (Songdo Central Park & Chinatown)',
    nameDe: 'Incheon (Songdo & Chinatown)',
    nameKr: '인천 송도 / 차이나타운',
    region: 'Incheon',
    lat: 37.3925,
    lng: 126.6392,
    description: 'Futuristic Tri-bowl canal architecture, fairytale village & sunset port.',
    addressKr: '인천광역시 연수구 컨벤시아대로 160 (송도동)',
  },
  {
    id: 'incheon-yeongjongdo',
    name: 'Incheon (Yeongjongdo / Eurwang-dong / Made Lim)',
    nameDe: 'Incheon (Yeongjongdo / Eurwang-dong & Made Lim)',
    nameKr: '인천 영종도 / 을왕동',
    region: 'Incheon',
    lat: 37.4640,
    lng: 126.3696,
    description: 'Island haven: Made Lim church forest cafe, Masian sunset coast & Inspire Aurora.',
    addressKr: '인천광역시 중구 용유서로479번길 42 (을왕동 875-1)',
  },
  {
    id: 'gangwon-sokcho',
    name: 'Gangwon (Sokcho & Seoraksan)',
    nameDe: 'Gangwon (Sokcho & Seoraksan)',
    nameKr: '강원 속초 / 설악산',
    region: 'Gangwon',
    lat: 38.2070,
    lng: 128.5918,
    description: 'Breathtaking granite peaks, coastal seafood villages & blue East Sea.',
    addressKr: '강원특별자치도 속초시 설악산로 1091',
  },
  {
    id: 'gangwon-gangneung',
    name: 'Gangwon (Gangneung & BTS Bus Stop)',
    nameDe: 'Gangwon (Gangneung)',
    nameKr: '강원 강릉',
    region: 'Gangwon',
    lat: 37.7519,
    lng: 128.8761,
    description: 'Famous Anmok coffee beach, Jumunjin Goblin filming spot & BTS beach stop.',
    addressKr: '강원특별자치도 강릉시 주문진읍 향호리 8-55',
  },
  {
    id: 'jeonju',
    name: 'Jeonju (Hanok Village)',
    nameDe: 'Jeonju (Hanok Dorf)',
    nameKr: '전주 한옥마을',
    region: 'Jeonju',
    lat: 35.8152,
    lng: 127.1539,
    description: 'Korea’s largest traditional Hanok village with 800+ curved tiled roof houses.',
    addressKr: '전북특별자치도 전주시 완산구 기린대로 99 (풍남동)',
  },
  {
    id: 'daegu-dongseongno',
    name: 'Daegu (83 Tower / Seomun / Dongseong-ro)',
    nameDe: 'Daegu (83 Tower / Seomun Nachtmarkt)',
    nameKr: '대구 동성로 / 83타워',
    region: 'Daegu',
    lat: 35.8685,
    lng: 128.5940,
    description: '83 Tower skyline view, Seomun Night Market street food & Kim Gwangseok-gil mural alley.',
    addressKr: '대구광역시 중구 동성로2길 81',
  },
];
